// extracted by mini-css-extract-plugin
module.exports = {"marginRight":"components_marginRight__AeS72"};
module.exports.__checksum = "5dd492922ffa"
